<main class="main">
  <!-- Div con titolo e sottotitolo -->
  <div class="main-content">
    <div class="dash-heading">
      <div class="dash-heading-icon"><i class="fas fa-chart-bar"></i></div>
      <div>
        <h1 class="main-title">Statistiche</h1>
        <p class="main-subtitle">Menu statistiche per colli e bolle</p>
      </div>
    </div>

    <h2 class="section-title">Statistiche disponibili</h2>
    <div class="card-container">
      <a class="card cat-blue" [routerLink]="'/statistics-affidati'" *ngIf="functionService.canRead('statistics-affidati')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-bar"></i></div>
          <div class="card-text">
            <h3>Affidati</h3>
            <p>Monitora le bolle e i colli affidati</p>
          </div>
        </div>
      </a>

      <a class="card cat-green" [routerLink]="'/statistics-consegnati'" *ngIf="functionService.canRead('statistics-consegnati')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-bar"></i></div>
          <div class="card-text">
            <h3>Consegnati</h3>
            <p>Monitora i colli consegnati</p>
          </div>
        </div>
      </a>

      <a class="card cat-cyan" [routerLink]="'/statistics-by-day'" *ngIf="functionService.canRead('statistics-by-day')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-bar"></i></div>
          <div class="card-text">
            <h3>Statistica Giorni</h3>
            <p>Affidati, consegnati, on time e in range giorno per giorno</p>
          </div>
        </div>
      </a>

      <a class="card cat-purple" [routerLink]="'/statistics-ope-by-day'" *ngIf="functionService.canRead('statistics-ope-by-day')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-bar"></i></div>
          <div class="card-text">
            <h3>Statistica Giorni Operativa</h3>
            <p>Consegnati, on time e in range effettivi giorno per giorno</p>
          </div>
        </div>
      </a>

      <a class="card cat-orange" [routerLink]="'/statistics-returns-by-day'" *ngIf="functionService.canRead('statistics-returns-by-day')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-bar"></i></div>
          <div class="card-text">
            <h3>Statistica Giorni Resi</h3>
            <p>Totali resi stato 1, 2, 3, 4, 5 giorno per giorno</p>
          </div>
        </div>
      </a>
    </div>

    <h2 class="section-title">KPI</h2>
    <div class="card-container">
      <a class="card cat-teal" [routerLink]="'/statistics-kpi-colli'" *ngIf="functionService.canRead('statistics-kpi-colli')">
        <div class="card-content vertical">
          <div class="card-icon"><i class="fas fa-chart-bar"></i></div>
          <div class="card-text">
            <h3>KPI colli</h3>
            <p>Statistiche colli affidati e consegnati</p>
          </div>
        </div>
      </a>
    </div>

  </div>
</main>